<style lang="scss">

</style>
<!--eslint-disable-->
<template>
  <section class="p-relative">
    <h3 class="mb-2 text-center">Cancel Call for</h3>

    <h4 class="mb-1 text-center">{{ call.prisoner.firstname }} {{ call.prisoner.lastname }}
      (#{{ call.prisoner.prisoner_number }})</h4>

    <section>
      <label>Please provide a reason</label>

      <b-form-select cy="reason"
                     v-model="reason" class="mb-1">
        <b-form-select-option value="">Please choose a reason for cancelling</b-form-select-option>
        <b-form-select-option v-for="reason in reasons" :value="reason">{{ reason }}</b-form-select-option>
      </b-form-select>

      <section v-if="reason === 'Other'">
        <label class="d-flex m-2 align-items-center">Cancellation reason
          <small class="ml-auto">{{ 50 - otherReason.length }} characters remaining</small>
        </label>
        <b-form-textarea v-model="otherReason" maxlength="50"
                         placeholder="Enter reason for cancelling"></b-form-textarea>
      </section>
    </section>

    <section class="d-inline-flex full-width mt-2" :class="{'disabled': loading}">
      <div class="ui-spacer"></div>
      <b-button class="mr-2" @click="close()">Close</b-button>
      <b-button variant="danger" @click="cancelCall()" :class="{'disabled': !isValid()}">Cancel Call</b-button>
    </section>
  </section>
</template>
<!--eslint-enable-->

<script>
import VisitService from '@/services/VisitService';
import {ERROR_CODES} from '@/util/errorCodes';

export default {
  components: {},
  props: {
    call: {
      required: true,
      type: Object,
    },
    redirect: {
      type: String,
      required: false
    }
  },
  data() {
    const reasons = [
      'Needs to be rescheduled by establishment',
      'Resident or Caller wants to reschedule',
      'Admin error',
      'Resident  can’t make it',
      'Operational reasons',
      'Resident has already used their allocated video calls',
      'Resident doesn’t want this visit',
      'Resident has left the establishment',
      'Resident has moved wing',
      'Not accepted in time',
      'Not approved to contact',
      'Change of Caller(s)',
    ];
    if (this.call.prison.prison_group_id !== '21a4a4957bfd41c1836ac1d127581975') {
      reasons.push('Other');
    }
    return {
      loading: false,
      reason: '',
      reasons,
      otherReason: '', // free text reason
    };
  },
  mounted() {

  },
  methods: {
    isValid() {
      let selected = this.reason.length > 0;
      let otherReason = this.otherReason.length <= 50 && this.otherReason.length > 0;

      if (this.reason === 'Other') {
        return otherReason;
      }

      return selected;
    },
    cancelCall() {
      this.loading = true;
      VisitService.cancelVisit(this.call._id, {
        cancellation_reason: this.reason === 'Other' ? this.otherReason : this.reason,
        metricAction: 'WebPortalNew',
      }).then(() => {
        this.$toast.success('The video call has been cancelled', {
          toastClassName: ['toast-std', 'success-toast'],
        });

        if(this.redirect) {
          this.$router.push(this.redirect);
        }

        this.close();
      }).catch(err => {
        const errorCheck = err && err.response && err.response.data;
        let message = 'Something went wrong cancelling the video call, please refresh the page and try again';

        if(errorCheck && err.response.data === ERROR_CODES.VISIT.CANT_CANCEL_HAS_BEGUN) {
          message = 'Cannot cancel a video call that has already begun.';
        }

        this.$toast.error(message, {
          toastClassName: ['toast-std', 'warning-toast'], timeout: 5000,
        });
      }).finally(() => {
        this.loading = false;
      });
    },
    close() {
      this.$emit('close', true); // emit a close
    }
  },
};
</script>
